module.exports = "/subscriptions/assets/cb551b7dd5bd36b3262ea0a978bf6be4.png";